<div (mouseenter)="this.dotComService.DisplaySubMenu('')">
    <div *ngIf="this.validBlog">
        <!-- this div is the title in text in white.  it has to lay on top as the image is darkened and the text would not show. -->
        <div class="row" style="width: 100%;margin: auto;position: absolute;top: 380px;text-align: center;z-index: 2;">
            <h1 *ngIf="myHarrellsService.bootstrapViewPortSize && myHarrellsService.bootstrapViewPortSize != '' && !(myHarrellsService.bootstrapViewPortSize == 'xs' || this.myHarrellsService.bootstrapViewPortSize == 'sm')"
                class="DINNextLTPro-Black whiteText" style="font-size:43px; text-transform: uppercase;"
                [innerHTML]="thisBlog.Title"></h1>
        </div>
        <!-- this div is the image that has a brightness css attribute to darken it so the text will show. -->
        <div *ngIf="myHarrellsService.bootstrapViewPortSize && myHarrellsService.bootstrapViewPortSize != '' && !(myHarrellsService.bootstrapViewPortSize == 'xs' || this.myHarrellsService.bootstrapViewPortSize == 'sm')"
            style="margin:auto;filter: brightness(50%); background-size: cover; background-position:center; padding-top:27vh; padding-bottom:27vh; max-height: 600px;"
            [ngStyle]="{backgroundImage: 'url(' + thisBlog.ImageName + ')'}">
            <div class="row">
                <div style="width:22%"></div>
                <div class="text-center whiteText" style="width:56%">
                    <!-- <h1 class="DINNextLTPro-Black whiteText" style="font-size:43px; text-transform: uppercase;">
                        {{this.dotComService.HtmlStringToPlainText(thisBlog.Title)}}
                    </h1> -->
                </div>
                <div style="width:22%"></div>
            </div>
        </div>

        <div class="row" style="margin-top:70px">
            <h2 class="Caecilia76BoldItalic greenText text-center" style="font-size:28px; line-height: 36px;"
                [innerHTML]="this.thisBlog.Title"></h2>
        </div>
        <div class="row mt-3" style="max-width:1100px; margin:auto">
            <div style="width:33%"></div>
            <div style="width:33%">
            <h1 *ngIf="!this.thisBlog.FirstName && !this.thisBlog.LastName" class="DIN2014Regular text-center"
                style="font-size:16px; line-height: 30px;">
                {{this.thisBlog.PublishDate}}</h1>
            <h1 *ngIf="this.thisBlog.FirstName || this.thisBlog.LastName" class="DIN2014Regular text-center"
                style="font-size:16px; line-height: 30px;">
                {{this.thisBlog.PublishDate}} - {{'By ' + this.thisBlog.FirstName}} {{this.thisBlog.LastName}}</h1>
            </div>
            <div style="width:33%">
                <a href="/knowledge"><h4 class="Din2014Regular blackText"
                    style="cursor:pointer; font-size:16px; font-weight:700; text-decoration: underline !important;text-align: right;"
                    >VIEW ALL BLOGS</h4></a>
            </div>
        </div>
        <div class="row mt-3" id='blogCMSContainer'  >
            <div style="padding-left:40px; padding-right:40px; max-width: 850px; text-align: center; margin:auto" [innerHTML]="thisBlog.Content"></div>
        </div>

        <div class="row" style="max-width:1000px; margin:auto;margin-bottom:70px; border-top:solid 1px grey">
            <h2 class="Caecilia76BoldItalic greenText mb-5" style="margin-top:70px; font-size:36px;">Related Resources
            </h2>
            <div class="featuredPostContainer" (click)="GoToBlog(this.otherFeaturedPost1)" style="cursor:pointer">
                <img class="imageContainer" src={{this.otherFeaturedPost1.ImageName}} alt="post image">
                <h2 class="DIN2014Bold mt-3" style="font-size:19px; line-height:22px; letter-spacing: .38px;">
                    FEATURED RESOURCE:</h2>
                <h3 class="DIN2014Bold" style="font-size:19px; line-height:22px; letter-spacing: .38px;"
                    [innerHTML]="this.otherFeaturedPost1.Title"></h3>
                <h4 class="DIN2014Regular" style="font-size:16px; line-height: 30px;">
                    {{this.otherFeaturedPost1.RevisionAuthor}}</h4>
                <h5 class="DIN2014Regular greenText"
                    style="cursor:pointer; margin-top:20px; font-size:16px; line-height: 19px; font-weight:700; text-decoration-line: underline;">
                    READ ARTICLE ></h5>
            </div>
            <div class="featuredPostContainer" (click)="GoToBlog(this.otherFeaturedPost2)" style="cursor:pointer">
                <img class="imageContainer" src={{this.otherFeaturedPost2.ImageName}} alt="post image">
                <h2 class="DIN2014Bold mt-3" style="font-size:19px; line-height:22px; letter-spacing: .38px;">
                    FEATURED RESOURCE:</h2>
                <h3 class="DIN2014Bold" style="font-size:19px; line-height:22px; letter-spacing: .38px;"
                    [innerHTML]="this.otherFeaturedPost2.Title"></h3>
                <h4 class="DIN2014Regular" style="font-size:16px; line-height: 30px;">
                    {{this.otherFeaturedPost2.RevisionAuthor}}</h4>
                <h5 class="DIN2014Regular greenText"
                    style="cursor:pointer; margin-top:20px; font-size:16px; line-height: 19px; font-weight:700; text-decoration-line: underline;">
                    READ ARTICLE ></h5>
            </div>
            <div class="featuredPostContainer" (click)="GoToBlog(this.otherFeaturedPost3)" style="cursor:pointer">
                <img class="imageContainer" src={{this.otherFeaturedPost3.ImageName}} alt="post image">
                <h2 class="DIN2014Bold mt-3" style="font-size:19px; line-height:22px; letter-spacing: .38px;">
                    FEATURED RESOURCE:</h2>
                <h3 class="DIN2014Bold" style="font-size:19px; line-height:22px; letter-spacing: .38px;"
                    [innerHTML]="this.otherFeaturedPost3.Title"></h3>
                <h4 class="DIN2014Regular" style="font-size:16px; line-height: 30px;">
                    {{this.otherFeaturedPost3.RevisionAuthor}}</h4>
                <h5 class="DIN2014Regular greenText"
                    style="cursor:pointer; margin-top:20px; font-size:16px; line-height: 19px; font-weight:700; text-decoration-line: underline;">
                    READ ARTICLE ></h5>
            </div>
        </div>

    </div>
    <div *ngIf="!this.validBlog  && !displayOops" class="text-center" style="min-height:50vh">
    </div>
    <div *ngIf="!this.validBlog  && displayOops" class="text-center" style="margin-top:30vh; margin-bottom:30vh">
        <h3 class="DIN2014Regular blackText" style="font-size: 24px; line-height: 33px;letter-spacing: .48px;">
            Oops! This resource is no longer available.</h3>
    </div>

</div><!-- end of blog -->